import { render, staticRenderFns } from "./GradeAuthorizationIndex.vue?vue&type=template&id=29235ae9"
import script from "./GradeAuthorizationIndex.js?vue&type=script&lang=js&external"
export * from "./GradeAuthorizationIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports